<template>
  <withTopNav :leftText="detail.activityConfigName" class="bonus" fixed>
    <div class="topBanner">
      <span class="label">{{ label }}</span>
      <div class="pt-8 flex-center-col-x">
        <h3 class="text-13 font-[600]">Pode Ser Coletado</h3>
        <div class="flex-center gap-2 my-3">
          <img :src="iMoney" class="size-9" />
          <p class="text-18 font-[600] text-[var(--theme-yellow)]">{{ formatter().format(info.rewardAmount) }}</p>
        </div>
        <img src="@a/assets/images/bn_bonus.png" v-if="info.rewardAmount > 0" @click="receber" class="size-15 mb-5" />
        <img src="@a/assets/images/bn_bonus2.png" v-else @click="!isLoggedin && showLoginOrRegPopup()" class="size-15 mb-5" />
        <p class="text-11 text-white/75 relative" @click="$router.push(`/bonus/history?activityId=${route.query.activityId}`)">Histórico> <span class="redPoint" v-if="info.recordCount > 0">{{ info.recordCount }}</span></p>
      </div>

    </div>

    <div class="text-center pt-4">
      <p class="text-15 mb-2">Contagem Para O Próximo Evento</p>

      <div class="countdown" v-if="timeToCountDown > 1000">
        <strong>{{ days }}</strong> <span>dias</span> <strong>{{ hours.toString().padStart(2, '0') }}</strong> <span>h</span> <strong>{{ minutes.toString().padStart(2, '0') }}</strong> <span>min</span> <strong>{{ seconds.toString().padStart(2, '0') }}</strong> <span>s</span>
      </div>
    </div>

    <div class="main m-4">
      <div class="rounded-8 overflow-hidden">
        <div class="flex-center-x p-2 bg-[var(--title-bg-color)] mb-0.5">
          <img src="@a/assets/images/i_pack.png" class="size-6 mr-2" />
          <p class="text-16 flex-1">Progresso dos Prêmios Atuais</p>
          <div class="text-12 flex-center gap-2 pl-8" @click="$router.push('/deposito')"><span>Fazer<br/>Depósito</span> <van-icon name="arrow" size="18" /></div>
        </div>
        <DataTable :columns :data="tableData" headBgColor="var(--odd-bg-color)" :bodyBgColor="['var(--even-bg-color)']" />
      </div>

      <ActivityDesc class="my-4" title="Descricão da Atividade" :list="descList" />
    </div>
  </withTopNav>
</template>

<script setup lang="tsx">
  import withTopNav from '@/layouts/withTopNav.vue'
  import DataTable from '@a/components/DataTable/index.vue'
  import ActivityDesc from '@a/components/ActivityDesc/index.vue'
  import useTimeCountDown from '@/hooks/useTimeCountDown'
  import iMoney from '@a/assets/images/i_money2.png'
  import iChecked from '@a/assets/images/i_checked2.png'
  import iUnchecked from '@a/assets/images/i_unchecked.png'
  import { getBonusActivityInfo, getBonusActivityInfoWithoutAuth } from '@/api'
  import { useUserInfo } from '@/store'
  import { formatter } from '@/utils'
  import showLoginOrRegPopup from '@a/components/showLoginOrRegPopup'
  import showPopup from '@a/components/showPopup'
  import Tip from '@a/components/Tip/index.vue'
  import { useActivity } from '@/hooks/useActivity'
  import type { iBonusActivityInfo } from '@/types/index'

  const route = useRoute()
  const activityId = route.query.activityId as string
  const isLoggedin = computed(() => useUserInfo().isLoggedin)
  const activity = useActivity(activityId, {
    getInfo: getBonusActivityInfo,
    getInfoWithoutAuth: getBonusActivityInfoWithoutAuth
  })
  const detail = computed(() => activity.data.value.detail)
  const info = computed(() => activity.data.value.info || {
    depositType: 'First',
    rewardAmount: 0,
    status: 'Unarchived',
    expireTime: 0,
    recordCount: 0,
    rewardId: '',
    detailList: [],
  }) as Ref<iBonusActivityInfo>
  const descList = computed(() => activity.data.value.descList || [])
  const label = computed(() => {
    return info.value.depositType == 'First' ? 'Primeiro' : info.value.depositType == 'Single' ? 'Cada' : 'Acumulado'
  })
  const timeToCountDown = computed(() => info.value.expireTime - Date.now())
  const { days, hours, minutes, seconds, changeTime } = useTimeCountDown(timeToCountDown.value)

  watch(timeToCountDown, (newVal) => {
    if (newVal > 1000) changeTime(newVal)
  }, {once: true})

  const columns = [
    {
      title: 'Depósito',
      key: 'depositAmount',
      render: (row) => {
        return <span>{formatter().format(row.depositAmount || 0)}</span>
      }
    },
    {
      title: 'Prêmio',
      key: 'k2',
      colClass: '!flex-[1.3]',
      render: (row, i) => {
        const isFixed = info.value.rewardType == 'CashFixed'

        return <div class="flex-center-col-x gap-0.5 text-white/75 py-2 text-11">
          { isFixed ?
            <><img src={iMoney} class="size-6" /> <span>Valor：R${row.startRange.replace('.', ',')}-{row.showMaxAmount.replace('.', ',')}</span></> :
            <div class="flex-center-y text-[var(--theme-yellow)] whitespace-nowrap">
              <img src={iMoney} class="size-6 mr-2" /> x{row.startRange.replace('.', ',')}% ~ {row.showMaxAmount.replace('.', ',')}%
            </div>
          }

          {i == tableData.value.length - 1 && !isFixed && <span>Maior: {formatter().format(+info.value.maxRewardAmount)}</span>}
        </div>
      }
    },
    {
      title: 'Progresso',
      key: 'k3',
      render: (row) => {
        return <div class="flex-center-col-x gap-1">
                { info.value.depositType == 'Accumulate' ? renderAccumulate(row) : renderNotAccumulate(row) }
              </div>
      }
    }
  ]

  const renderAccumulate = (row) => {
    return row.status == 'Unarchived' ?
            (<div class="text-center">
              { formatter().format(row.totalRechargeAmount || 0) }
              <div class="h-[3px] min-w-[60px] bg-white/30 rounded-full overflow-hidden mt-1">
                <div class="w-12 h-full bg-[var(--theme-yellow)]" style={{ width: `${row.totalRechargeAmount / row.depositAmount * 100}%` }}/>
              </div>
            </div>) :
            <div class="flex-center-x gap-1"> <img src={iChecked} class="size-5" /> </div>
  }

  const renderNotAccumulate = (row) => {
    return row.status == 'Unarchived' ?
            <div class="flex-center-x gap-1"> <img src={iUnchecked} class="size-5" /> </div> :
            row.singleCount == 1 ?
              <div class="flex-center-x gap-1"> <img src={iChecked} class="size-5" /> </div> :
              row.singleCount > 1 ?
                <div class="flex-center bg-[var(--theme-gray-green)] gap-1 rounded-full pl-1.5 pr-0.5 text-12 h-6">
                  {row.singleCount} <img src={iChecked} class="size-5" />
                </div> :
              <div class="flex-center-x gap-1"> <img src={iChecked} class="size-5" /> </div>
  }

  const tableData = computed(() => info.value.detailList || [])

  const receber = async () => {
    const onSuccess = async () => {
      const res = await activity.getDetail(activityId, getBonusActivityInfo)
      Object.assign(info.value, res)
    }
    showPopup(<Tip
      amount={info.value.rewardAmount}
      type='bonus'
      flowType="DepositReward"
      rewardId={info.value.rewardId}
      activityId={activityId}
      onSuccess={onSuccess}
    />)
  }
</script>

<style lang="scss">
.bonus {
  font-size: 13px;

  .topBanner {
    @apply bgs-[url('@a/assets/images/bg_bonus.png')] w-[343px] h-[237px] mx-auto mt-6 relative text-center;

    .label {
      @apply text-11 text-[var(--theme-text-dark)] font-[600] absolute-lt-[14px_0] wh-[68px_30px] leading-30;
    }

    .redPoint {
      @apply text-11 text-white bg-[var(--theme-red)] absolute-rt-[-18px_-5px] size-3.5 rounded-full;
    }
  }

  .countdown {
    @apply flex-center-x items-end py-3;

    strong{
      @apply size-11.5 rounded-4 bg-[var(--theme-gray-green40)] text-white text-30 flex-center font-[600] tracking-wider;
    }

    span{
      @apply text-11 min-w-5.5 px-1 text-left;
    }
  }
}
</style>
